import { useSearchParams } from 'react-router-dom';
import { AuditTimeline } from '@components/AuditTrail/AuditTimeline';
import { Typography } from '@mui/material';
import { BasePage } from './bases/BasePage';
import { BreadcrumbSubBar } from '@components/BreadcrumbSubBar';

export const AuditHistory = () => {
    const [params] = useSearchParams();
    const entityPk = params.get('entityPk') ?? '';

    if (!entityPk) return <Typography>No audit history available.</Typography>;

    return (
        <BasePage>
            <BreadcrumbSubBar />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <AuditTimeline entityPk={entityPk} />
            </div>
        </BasePage>
    );
};
